/**
 * 
 * change title
 * 
 * @param title
 * 
 * @returns title
 *  
 */
export function changetitle(title:any){

/*    title = title.replace(/【/,"");
    title = title.replace(/】/,"");
*/

    title = title.replace(/1円～/,"");
    title = title.replace(/1円/,"");
/*    title = title.replace(/同梱不可/,"");
    title = title.replace(/未開封/,"");
    title = title.replace(/箱なし/,"");
    title = title.replace(/ジャンク/,"");
    title = title.replace(/即決/,"");
    title = title.replace(/送料無料/,"");
    title = title.replace(/大量/,"");
*/

    return title;

}